import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-variable-benefit-payment-change-warning-banner',
  templateUrl: './variable-benefit-payment-change-warning-banner.component.html',
  styleUrls: ['./variable-benefit-payment-change-warning-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VariableBenefitPaymentChangeWarningBannerComponent {
  @Input({ required: true }) bannerTitle!: string;
  @Input({ required: true }) bannerDescription!: string;
  @Output() goToSubmission = new EventEmitter<void>();
}
